import React from "react";
import {MoonIcon, SunIcon} from "@heroicons/react/20/solid";
import {useTheme} from "./useTheme";

/**
 * Compact Light/Dark theme switch. Rendered as a setting (not a nav link),
 * so it reads as a small labeled control rather than a full menu row.
 */
export default function ThemeToggle() {
    const {isDark, toggleTheme} = useTheme();

    return (
        <button
            type="button"
            onClick={toggleTheme}
            aria-pressed={isDark}
            aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
            className="flex w-full items-center justify-between rounded-lg px-1 py-2 text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
            <span className="font-medium">Appearance</span>
            <span className="inline-flex items-center gap-x-2 rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-700 ring-1 ring-inset ring-gray-200 dark:bg-gray-800 dark:text-gray-200 dark:ring-gray-700">
                {isDark
                    ? <SunIcon className="h-4 w-4 text-pink-500" aria-hidden="true"/>
                    : <MoonIcon className="h-4 w-4 text-pink-500" aria-hidden="true"/>}
                {isDark ? "Light" : "Dark"}
            </span>
        </button>
    );
}
